/* istanbul ignore file */
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ApolloProvider } from "@apollo/client";
import { Provider } from "react-redux";

import { ErrorBoundary } from "@datadog/browser-rum-react";

import CssBaseline from "@mui/material/CssBaseline";
import ThemeProvider from "@mui/material/styles/ThemeProvider";

import { theme } from "@covertree/theme";
import { ErrorFallback } from "@covertree/ui";

import { router } from "@routing/router";
import { client } from "@apolloClient/client";
import { store } from "@redux/store";

export default function App() {
  return (
    <ErrorBoundary fallback={ErrorFallback}>
      <Provider store={store}>
        <ApolloProvider client={client}>
          <ToastContainer hideProgressBar />
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <RouterProvider router={router} />
          </ThemeProvider>
        </ApolloProvider>
      </Provider>
    </ErrorBoundary>
  );
}
